/* ==========================================================================
   vh-reels — vídeos flutuantes (bolha + player tipo stories)

   Sem dependência de jQuery: o tema carrega jQuery, mas prender este widget
   a ele significaria esperar o bundle inteiro antes da bolha aparecer.

   Toda leitura/escrita de localStorage passa por try/catch: em aba anônima
   ou com cookies de terceiros bloqueados o acesso lança exceção, e o widget
   não pode cair por causa disso.
   ========================================================================== */

(function () {
  'use strict';

  // Dois pontos da pagina podem pedir este arquivo (bolha flutuante e
  // fileira "Recebidos"). Script duplicado executa duas vezes.
  if (window.__vhReelsLoaded) return;
  window.__vhReelsLoaded = true;

  var LS_DISMISS = 'vh-reels:dismissed';
  var LS_LIKES = 'vh-reels:likes';
  var LS_COMMENTS = 'vh-reels:comments';
  var LS_NAME = 'vh-reels:name';

  /* ---------------------------------------------------------------- utils */

  function store(key, fallback) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function save(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (e) {
      return false;
    }
  }

  function svg(paths, attrs) {
    var extra = attrs || '';
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" ' + extra + '>' + paths + '</svg>';
  }

  var ICONS = {
    play: svg('<path d="M8 5v14l11-7z"/>'),
    close: svg('<path d="M5 5l14 14M19 5L5 19" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>'),
    heart: svg('<path d="M20.8 5.6a5 5 0 0 0-7.1 0L12 7.3l-1.7-1.7a5 5 0 1 0-7.1 7.1l8.8 8.8 8.8-8.8a5 5 0 0 0 0-7.1z"/>'),
    comment: svg('<path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 8.9 8.9 0 0 1-3.9-.9L3 20.5l1.6-4.8A8.4 8.4 0 0 1 12 3.1a8.4 8.4 0 0 1 9 8.4z"/>'),
    share: svg('<path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7M12 15V3m0 0L8.5 6.5M12 3l3.5 3.5"/>'),
    soundOn: svg('<path d="M11 5 6 9H3v6h3l5 4V5z" fill="currentColor" stroke="none"/><path d="M15.5 8.5a4.5 4.5 0 0 1 0 7M18.5 5.5a8.5 8.5 0 0 1 0 13" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>'),
    soundOff: svg('<path d="M11 5 6 9H3v6h3l5 4V5z" fill="currentColor" stroke="none"/><path d="M16 9.5l5 5m0-5l-5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>'),
    up: svg('<path d="M18 15l-6-6-6 6"/>'),
    down: svg('<path d="M6 9l6 6 6-6"/>'),
    send: svg('<path d="M3 11.5 21 3l-8.5 18-2.2-7.3L3 11.5z"/>')
  };

  function el(tag, className, parent) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (parent) parent.appendChild(node);
    return node;
  }

  function formatCount(n) {
    if (n >= 1000000) return (n / 1000000).toFixed(1).replace('.0', '') + 'M';
    if (n >= 1000) return (n / 1000).toFixed(1).replace('.0', '') + 'mil';
    return String(n);
  }

  function timeAgo(ts) {
    var diff = Math.floor((Date.now() - ts) / 1000);
    if (diff < 60) return 'agora';
    if (diff < 3600) return 'há ' + Math.floor(diff / 60) + ' min';
    if (diff < 86400) return 'há ' + Math.floor(diff / 3600) + ' h';
    if (diff < 2592000) return 'há ' + Math.floor(diff / 86400) + ' d';
    return new Date(ts).toLocaleDateString('pt-BR');
  }

  /* ------------------------------------------------------------- componente */

  function VHReels(root) {
    this.root = root;
    this.id = root.getAttribute('data-vh-reels');

    var payload = root.querySelector('[data-vh-reels-data]');
    if (!payload) return;

    try {
      this.data = JSON.parse(payload.textContent);
    } catch (e) {
      return;
    }

    this.videos = (this.data.videos || []).filter(function (v) {
      return v.mp4 || v.embed || v.poster;
    });
    if (!this.videos.length) return;

    this.cfg = this.data.settings || {};
    this.index = 0;
    this.modalBuilt = false;
    this.muted = true;
    this.designMode = !!(window.Shopify && window.Shopify.designMode);
    this.mode = root.getAttribute('data-vh-reels-mode') || 'bubble';

    if (this.mode === 'bubble') {
      if (!this.designMode && this.isDismissed()) return;
      if (this.cfg.hideOnMobile && window.matchMedia('(max-width: 749px)').matches) return;

      this.buildBubble();
      this.scheduleReveal();
    } else {
      this.setupGrid();
    }

    this.ready = true;
  }

  /* --------------------------------------------------------------- dispensa */

  VHReels.prototype.isDismissed = function () {
    // 0 = nunca esconder. Checado antes de ler o armazenamento para que
    // mudar o ajuste para 0 valha na hora, inclusive para quem ja fechou
    // a bolha antes e ainda tem a dispensa guardada no navegador.
    if (this.cfg.dismissHours === 0) return false;
    var until = store(LS_DISMISS, {})[this.id];
    return !!until && until > Date.now();
  };

  VHReels.prototype.dismiss = function () {
    // Atencao: (dismissHours || 24) transformaria 0 em 24, que e o oposto
    // do que 0 significa aqui. Por isso o teste explicito.
    var horas = typeof this.cfg.dismissHours === "number" ? this.cfg.dismissHours : 24;
    if (horas > 0) {
      var all = store(LS_DISMISS, {});
      all[this.id] = Date.now() + horas * 3600000;
      save(LS_DISMISS, all);
    }

    this.stopBubble();
    this.bubble.classList.remove('is-visible');
    var self = this;
    window.setTimeout(function () {
      if (self.bubble) self.bubble.setAttribute('hidden', '');
    }, 260);
  };

  /* -------------------------------------------------- fileira (modo grid) */

  VHReels.prototype.setupGrid = function () {
    var self = this;
    var thumbs = this.root.querySelectorAll('[data-vh-open]');
    if (!thumbs.length) return;

    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener('click', function (ev) {
        ev.preventDefault();
        self.open(parseInt(thumb.getAttribute('data-vh-open'), 10) || 0);
      });
    });

    if (this.cfg.autoplayPreview === false) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var play = function (thumb) {
      var media = thumb.querySelector('video');
      if (!media) return;
      if (!media.getAttribute('src')) {
        var src = media.getAttribute('data-vh-rcb-src');
        if (!src) return;
        media.src = src;
        media.preload = 'auto';
      }
      media.muted = true;
      var p = media.play();
      if (p && p.then) {
        p.then(function () { thumb.classList.add('is-playing'); })
         .catch(function () { /* autoplay bloqueado: fica na capa */ });
      } else {
        thumb.classList.add('is-playing');
      }
    };

    var stop = function (thumb) {
      var media = thumb.querySelector('video');
      if (media) media.pause();
      thumb.classList.remove('is-playing');
    };

    if (!window.IntersectionObserver) {
      Array.prototype.forEach.call(thumbs, play);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) play(entry.target);
        else stop(entry.target);
      });
    }, { threshold: 0.35 });

    Array.prototype.forEach.call(thumbs, function (thumb) { io.observe(thumb); });
    this.gridIO = io;
    this.gridThumbs = thumbs;

    // Aba em segundo plano nao precisa de previa rolando.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) return;
      Array.prototype.forEach.call(thumbs, stop);
    });

    this.gridStopAll = function () { Array.prototype.forEach.call(thumbs, stop); };
  };

  /* ----------------------------------------------------------------- bolha */

  VHReels.prototype.buildBubble = function () {
    var self = this;
    var cfg = this.cfg;

    // div com role=button em vez de <button>: o botão de fechar fica dentro
    // da bolha, e botão aninhado em botão é HTML inválido.
    var bubble = el('div', 'vh-reels__bubble vh-reels__bubble--' + (cfg.side || 'right'));
    if (this.videos.length < 2) bubble.classList.add('vh-reels__bubble--single');
    bubble.setAttribute('role', 'button');
    bubble.setAttribute('tabindex', '0');
    bubble.setAttribute('aria-label', cfg.openLabel || 'Assistir aos vídeos da loja');

    var poster = el('img', 'vh-reels__bubble-poster', bubble);
    poster.alt = '';
    poster.loading = 'lazy';
    poster.decoding = 'async';

    var video = el('video', 'vh-reels__bubble-media', bubble);
    video.muted = true;
    video.defaultMuted = true;
    video.loop = this.videos.length < 2;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('aria-hidden', 'true');
    video.preload = 'none';
    video.tabIndex = -1;

    var track = el('div', 'vh-reels__track', bubble);
    this.trackFills = [];
    for (var i = 0; i < this.videos.length; i++) {
      var item = el('div', 'vh-reels__track-item', track);
      this.trackFills.push(el('div', 'vh-reels__track-fill', item));
    }

    if (cfg.badgeText) {
      var badge = el('span', 'vh-reels__badge', bubble);
      badge.textContent = cfg.badgeText;
    }

    var play = el('span', 'vh-reels__bubble-play', bubble);
    play.innerHTML = ICONS.play;

    var close = el('button', 'vh-reels__bubble-close', bubble);
    close.type = 'button';
    close.innerHTML = ICONS.close;
    close.setAttribute('aria-label', cfg.closeLabel || 'Fechar vídeos');

    bubble.addEventListener('click', function (ev) {
      if (close.contains(ev.target)) return;
      self.open(self.index);
    });

    bubble.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Enter' && ev.key !== ' ' && ev.key !== 'Spacebar') return;
      ev.preventDefault();
      self.open(self.index);
    });

    close.addEventListener('click', function (ev) {
      ev.stopPropagation();
      self.dismiss();
    });

    this.bubble = bubble;
    this.bubblePoster = poster;
    this.bubbleVideo = video;
    this.root.appendChild(bubble);
    this.root.removeAttribute('hidden');

    video.addEventListener('ended', function () {
      if (self.videos.length > 1) self.nextBubble();
    });

    video.addEventListener('playing', function () {
      video.classList.add('is-playing');
    });

    video.addEventListener('timeupdate', function () {
      if (!video.duration) return;
      self.setTrack(self.index, video.currentTime / video.duration);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self.stopBubble();
      else if (!self.modalOpen && self.revealed) self.playBubble();
    });
  };

  VHReels.prototype.setTrack = function (index, ratio) {
    for (var i = 0; i < this.trackFills.length; i++) {
      var pct = i < index ? 100 : i > index ? 0 : Math.max(0, Math.min(1, ratio)) * 100;
      this.trackFills[i].style.width = pct + '%';
    }
  };

  VHReels.prototype.scheduleReveal = function () {
    var self = this;
    var delay = this.designMode ? 0 : (this.cfg.delaySeconds || 0) * 1000;

    window.setTimeout(function () {
      self.revealed = true;
      self.bubble.classList.add('is-visible');
      self.showBubble(0);
    }, delay);
  };

  VHReels.prototype.showBubble = function (index) {
    var video = this.videos[index];
    if (!video) return;

    this.index = index;
    this.setTrack(index, 0);
    this.bubbleVideo.classList.remove('is-playing');

    if (video.poster) {
      this.bubblePoster.src = video.poster;
      this.bubblePoster.style.display = '';
    } else {
      this.bubblePoster.style.display = 'none';
    }

    // Vídeo de plataforma externa (YouTube/Vimeo) não toca na bolha: só a capa.
    if (!video.mp4 || !this.cfg.autoplayPreview || this.saveData()) {
      this.bubbleVideo.removeAttribute('src');
      this.bubbleVideo.load();
      if (this.videos.length > 1) this.startTimer();
      return;
    }

    this.bubbleVideo.src = video.mp4;
    this.bubbleVideo.preload = 'auto';
    this.playBubble();
  };

  VHReels.prototype.saveData = function () {
    var c = navigator.connection;
    return !!(c && c.saveData);
  };

  VHReels.prototype.playBubble = function () {
    if (!this.bubbleVideo || !this.bubbleVideo.src) return;
    var p = this.bubbleVideo.play();
    if (p && p.catch) p.catch(function () { /* autoplay bloqueado: fica na capa */ });
  };

  VHReels.prototype.stopBubble = function () {
    if (this.bubbleVideo) this.bubbleVideo.pause();
    window.clearTimeout(this.timer);
  };

  VHReels.prototype.startTimer = function () {
    var self = this;
    var seconds = this.cfg.rotateSeconds || 8;
    window.clearTimeout(this.timer);

    var started = Date.now();
    var tick = function () {
      var ratio = (Date.now() - started) / (seconds * 1000);
      self.setTrack(self.index, ratio);
      if (ratio >= 1) self.nextBubble();
      else self.timer = window.setTimeout(tick, 100);
    };
    this.timer = window.setTimeout(tick, 100);
  };

  VHReels.prototype.nextBubble = function () {
    if (this.modalOpen) return;
    this.showBubble((this.index + 1) % this.videos.length);
  };

  /* ----------------------------------------------------------------- modal */

  VHReels.prototype.buildModal = function () {
    var self = this;
    var cfg = this.cfg;

    // O modal vai para o <body>, não para dentro da seção: um ancestral com
    // transform (o drawer do menu usa) quebraria o position:fixed. Por sair
    // da seção, ele leva junto a classe base e as cores vindas do editor.
    var modal = el('div', 'vh-reels vh-reels__modal');
    var computed = window.getComputedStyle(this.root);
    ['--vh-reels-accent', '--vh-reels-accent-ink'].forEach(function (prop) {
      var value = computed.getPropertyValue(prop);
      if (value) modal.style.setProperty(prop, value.trim());
    });
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', cfg.dialogLabel || 'Vídeos da loja');
    modal.hidden = true;

    var backdrop = el('button', 'vh-reels__backdrop', modal);
    backdrop.type = 'button';
    backdrop.setAttribute('aria-label', cfg.closeLabel || 'Fechar');
    backdrop.addEventListener('click', function () { self.close(); });

    var stage = el('div', 'vh-reels__stage', modal);
    var player = el('div', 'vh-reels__player', stage);

    this.slides = this.videos.map(function (video, i) {
      return self.buildSlide(video, i, player);
    });

    // trilha de progresso e barra superior ficam acima dos slides
    var ptrack = el('div', 'vh-reels__player-track', player);
    this.playerFills = [];
    for (var i = 0; i < this.videos.length; i++) {
      var item = el('div', 'vh-reels__track-item', ptrack);
      this.playerFills.push(el('div', 'vh-reels__track-fill', item));
    }
    if (this.videos.length < 2) ptrack.style.display = 'none';

    var topbar = el('div', 'vh-reels__topbar', player);
    var brand = el('div', 'vh-reels__brand', topbar);
    if (cfg.brandLogo) {
      var logo = el('img', 'vh-reels__brand-logo', brand);
      logo.src = cfg.brandLogo;
      logo.alt = '';
    }
    var bname = el('span', 'vh-reels__brand-name', brand);
    bname.textContent = cfg.brandName || '';

    el('div', 'vh-reels__topbar-spacer', topbar);

    var soundBtn = el('button', 'vh-reels__icon-btn vh-reels__sound', topbar);
    soundBtn.type = 'button';
    soundBtn.innerHTML = ICONS.soundOff;
    soundBtn.setAttribute('aria-label', 'Ativar som');
    soundBtn.addEventListener('click', function () { self.toggleSound(); });
    this.soundBtn = soundBtn;

    var closeBtn = el('button', 'vh-reels__icon-btn', topbar);
    closeBtn.type = 'button';
    closeBtn.innerHTML = ICONS.close;
    closeBtn.setAttribute('aria-label', cfg.closeLabel || 'Fechar');
    closeBtn.addEventListener('click', function () { self.close(); });
    this.closeBtn = closeBtn;

    if (this.videos.length > 1) {
      var prev = el('button', 'vh-reels__nav vh-reels__nav--prev', player);
      prev.type = 'button';
      prev.innerHTML = ICONS.up;
      prev.setAttribute('aria-label', 'Vídeo anterior');
      prev.addEventListener('click', function () { self.go(self.index - 1); });

      var next = el('button', 'vh-reels__nav vh-reels__nav--next', player);
      next.type = 'button';
      next.innerHTML = ICONS.down;
      next.setAttribute('aria-label', 'Próximo vídeo');
      next.addEventListener('click', function () { self.go(self.index + 1); });

      this.prevBtn = prev;
      this.nextBtn = next;
    }

    if (cfg.enableComments) this.buildCommentsPanel(stage, player);

    // ---- trocar de post tocando na tela, como nos stories ----
    //
    // Esquerda = anterior, direita = proximo. Segurar pausa enquanto
    // estiver pressionado. Precisa conviver com o que ja existe na tela:
    // setas, botoes de som/fechar, curtir/comentar/compartilhar, card do
    // produto e CTA. Por isso o clique e ignorado quando nasce dentro de
    // qualquer um deles.
    var IGNORAR = ".vh-reels__nav, .vh-reels__topbar, .vh-reels__actions," +
                  " .vh-reels__product, .vh-reels__cta, .vh-reels__comments," +
                  " a, button, input, textarea";
    var ZONA_ESQUERDA = 0.33;   // mesmo proporcao que o Instagram usa
    var SEGURAR_MS = 250;       // acima disso e "segurar", nao toque
    var ARRASTO_MAX = 10;       // px: acima disso foi swipe, nao toque

    var tapX = 0, tapY = 0, tapT = 0, segurando = false, holdTimer = null;

    function ehInterativo(alvo) {
      // SVG em navegador antigo pode nao ter closest
      return !!(alvo && alvo.closest && alvo.closest(IGNORAR));
    }

    function midiaAtual() {
      var slide = self.slides && self.slides[self.index];
      return slide ? slide._media : null;
    }

    player.addEventListener("pointerdown", function (ev) {
      if (ehInterativo(ev.target)) return;
      tapX = ev.clientX; tapY = ev.clientY; tapT = Date.now();
      segurando = false;
      clearTimeout(holdTimer);
      holdTimer = setTimeout(function () {
        segurando = true;
        var m = midiaAtual();
        if (m && !m.paused) m.pause();
      }, SEGURAR_MS);
    });

    player.addEventListener("pointerup", function (ev) {
      clearTimeout(holdTimer);
      if (!tapT) return;
      if (ehInterativo(ev.target)) { tapT = 0; return; }

      var dx = Math.abs(ev.clientX - tapX);
      var dy = Math.abs(ev.clientY - tapY);
      var durou = Date.now() - tapT;
      tapT = 0;

      if (segurando) {                    // estava pausado na mao: so retoma
        segurando = false;
        var m = midiaAtual();
        if (m && m.paused) m.play();
        return;
      }
      if (dx > ARRASTO_MAX || dy > ARRASTO_MAX) return;   // foi arrasto
      if (durou >= SEGURAR_MS) return;

      var r = player.getBoundingClientRect();
      if (!r.width) return;
      var rel = (ev.clientX - r.left) / r.width;

      // go() trava nas pontas (clampa o indice), entao no ultimo post um
      // toque a direita nao fazia nada. Nos stories o toque sempre anda:
      // do ultimo volta para o primeiro. Damos a volta aqui, sem mexer no
      // go(), para nao alterar as setas nem o avanco automatico do fim
      // do video, que devem continuar parando nas pontas.
      var total = self.slides ? self.slides.length : 0;
      if (total < 2) return;                 // um video so: nao ha para onde ir
      var alvo = rel < ZONA_ESQUERDA ? self.index - 1 : self.index + 1;
      if (alvo < 0) alvo = total - 1;
      if (alvo > total - 1) alvo = 0;
      self.go(alvo);
    });

    player.addEventListener("pointercancel", function () {
      clearTimeout(holdTimer);
      if (segurando) { var m = midiaAtual(); if (m && m.paused) m.play(); }
      segurando = false; tapT = 0;
    });

    // swipe vertical no mobile
    var y0 = null;
    player.addEventListener('touchstart', function (ev) {
      y0 = ev.touches[0].clientY;
    }, { passive: true });

    player.addEventListener('touchend', function (ev) {
      if (y0 === null) return;
      var dy = ev.changedTouches[0].clientY - y0;
      y0 = null;
      if (Math.abs(dy) < 60) return;
      self.go(dy < 0 ? self.index + 1 : self.index - 1);
    }, { passive: true });

    modal.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') { ev.stopPropagation(); self.close(); }
      else if (ev.key === 'ArrowDown') { ev.preventDefault(); self.go(self.index + 1); }
      else if (ev.key === 'ArrowUp') { ev.preventDefault(); self.go(self.index - 1); }
      else if (ev.key === 'Tab') self.trapFocus(ev);
    });

    this.modal = modal;
    this.player = player;
    document.body.appendChild(modal);
    this.modalBuilt = true;
  };

  VHReels.prototype.buildSlide = function (video, i, parent) {
    var self = this;
    var slide = el('article', 'vh-reels__slide', parent);
    slide.setAttribute('data-vh-index', String(i));

    var media = null;

    if (video.mp4) {
      media = el('video', 'vh-reels__video', slide);
      media.playsInline = true;
      media.setAttribute('playsinline', '');
      media.setAttribute('webkit-playsinline', '');
      media.muted = true;
      media.defaultMuted = true;
      media.loop = self.videos.length < 2 && !self.cfg.closeOnEnd;
      media.preload = 'none';
      if (video.poster) media.poster = video.poster;

      media.addEventListener('loadeddata', function () {
        slide.classList.remove('is-loading');
        slide.classList.add('is-ready');
      });

      media.addEventListener('timeupdate', function () {
        if (i !== self.index || !media.duration) return;
        self.setPlayerTrack(i, media.currentTime / media.duration);
      });

      media.addEventListener('ended', function () {
        // 'ended' de um slide fora de foco nao deve mexer na navegacao.
        if (i !== self.index) return;

        if (i < self.videos.length - 1) {
          self.go(i + 1);
          return;
        }

        // Fim do ultimo: devolve o visitante a pagina em vez de deixar o
        // player parado no ultimo quadro.
        if (self.cfg.closeOnEnd) self.close();
      });

      // Pausar passou a ser "segurar", como no Instagram. O clique simples
      // agora troca de post (ver as zonas de toque na montagem do player).
    }

    if (video.poster) {
      var poster = el('img', 'vh-reels__slide-poster', slide);
      poster.src = video.poster;
      poster.alt = video.title || '';
      poster.loading = 'lazy';
    }

    el('div', 'vh-reels__spinner', slide);
    el('div', 'vh-reels__scrim', slide);

    var info = el('div', 'vh-reels__info', slide);

    if (video.title) {
      var h = el('h3', 'vh-reels__title', info);
      h.textContent = video.title;
    }

    if (video.caption) {
      var p = el('p', 'vh-reels__caption', info);
      p.textContent = video.caption;
    }

    if (video.product) {
      var prod = el('a', 'vh-reels__product', info);
      prod.href = video.product.url;
      if (video.product.image) {
        var pimg = el('img', 'vh-reels__product-img', prod);
        pimg.src = video.product.image;
        pimg.alt = '';
        pimg.loading = 'lazy';
      }
      var pinfo = el('div', 'vh-reels__product-info', prod);
      var pname = el('div', 'vh-reels__product-name', pinfo);
      pname.textContent = video.product.title;
      var pprice = el('div', 'vh-reels__product-price', pinfo);
      pprice.appendChild(document.createTextNode(video.product.price));
      if (video.product.comparePrice) {
        var cmp = el('span', 'vh-reels__product-compare', pprice);
        cmp.textContent = video.product.comparePrice;
      }
    }

    if (video.ctaLink && video.ctaLabel) {
      var cta = el('a', 'vh-reels__cta', info);
      cta.href = video.ctaLink;
      cta.textContent = video.ctaLabel;
    }

    var actions = el('div', 'vh-reels__actions', slide);

    if (this.cfg.enableLikes) {
      var like = el('button', 'vh-reels__action vh-reels__action--like', actions);
      like.type = 'button';
      like.innerHTML = ICONS.heart;
      var likeCount = el('span', 'vh-reels__action-count', like);
      like.addEventListener('click', function () { self.toggleLike(i); });
      slide._like = like;
      slide._likeCount = likeCount;
      this.renderLike(slide, video);
    }

    if (this.cfg.enableComments) {
      var com = el('button', 'vh-reels__action vh-reels__action--comment', actions);
      com.type = 'button';
      com.innerHTML = ICONS.comment;
      var comCount = el('span', 'vh-reels__action-count', com);
      com.setAttribute('aria-label', 'Ver comentários');
      com.addEventListener('click', function () { self.toggleComments(true); });
      slide._commentCount = comCount;
    }

    if (this.cfg.enableShare) {
      var share = el('button', 'vh-reels__action vh-reels__action--share', actions);
      share.type = 'button';
      share.innerHTML = ICONS.share;
      share.setAttribute('aria-label', 'Compartilhar');
      share.addEventListener('click', function () { self.share(i); });
    }

    slide._media = media;
    slide._video = video;
    return slide;
  };

  VHReels.prototype.setPlayerTrack = function (index, ratio) {
    if (!this.playerFills) return;
    for (var i = 0; i < this.playerFills.length; i++) {
      var pct = i < index ? 100 : i > index ? 0 : Math.max(0, Math.min(1, ratio)) * 100;
      this.playerFills[i].style.width = pct + '%';
    }
  };

  /* -------------------------------------------------------- abrir / fechar */

  VHReels.prototype.open = function (index) {
    // O construtor sai cedo quando não há vídeo elegível para esta página.
    if (!this.ready) return;
    if (!this.modalBuilt) this.buildModal();

    this.lastFocus = document.activeElement;
    this.stopBubble();
    if (this.gridStopAll) this.gridStopAll();
    this.modalOpen = true;
    this.modal.hidden = false;
    document.documentElement.classList.add('vh-reels-lock');
    document.body.classList.add('vh-reels-lock');

    this.go(index || 0, true);
    this.closeBtn.focus();
  };

  VHReels.prototype.close = function () {
    if (!this.modalOpen) return;

    this.pauseAll();
    this.modalOpen = false;
    this.modal.hidden = true;
    this.toggleComments(false);
    document.documentElement.classList.remove('vh-reels-lock');
    document.body.classList.remove('vh-reels-lock');

    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    if (this.revealed && this.bubble && !this.bubble.hasAttribute('hidden')) {
      this.showBubble(this.index);
    }
  };

  VHReels.prototype.pauseAll = function () {
    if (!this.slides) return;
    this.slides.forEach(function (slide) {
      if (slide._media) slide._media.pause();
      // iframe: recarregar o src é a única forma de parar sem a API do player
      var frame = slide.querySelector('iframe');
      if (frame) frame.removeAttribute('src');
    });
  };

  VHReels.prototype.go = function (index, force) {
    if (!this.slides) return;

    var total = this.slides.length;
    if (index < 0) index = 0;
    if (index > total - 1) index = total - 1;
    if (index === this.index && !force) return;

    this.pauseAll();
    this.index = index;
    this.setPlayerTrack(index, 0);

    for (var i = 0; i < total; i++) {
      this.slides[i].classList.toggle('is-active', i === index);
    }

    if (this.prevBtn) this.prevBtn.disabled = index === 0;
    if (this.nextBtn) this.nextBtn.disabled = index === total - 1;

    this.activate(this.slides[index]);
    if (this.commentsPanel) this.renderComments();
    this.preload(index + 1);
  };

  VHReels.prototype.activate = function (slide) {
    var video = slide._video;

    if (slide._media) {
      if (!slide._media.getAttribute('src')) {
        slide.classList.add('is-loading');
        slide._media.src = video.mp4;
        slide._media.preload = 'auto';
      }
      slide._media.muted = this.muted;
      var p = slide._media.play();
      if (p && p.catch) p.catch(function () {});
      return;
    }

    if (video.embed && !slide.querySelector('iframe')) {
      var frame = document.createElement('iframe');
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.setAttribute('allowfullscreen', '');
      frame.title = video.title || 'Vídeo';
      slide.insertBefore(frame, slide.firstChild);
      slide.classList.add('is-ready');
      slide._frame = frame;
    }

    if (slide._frame) {
      slide._frame.src = video.embed + (video.embed.indexOf('?') > -1 ? '&' : '?') +
        'autoplay=1&mute=' + (this.muted ? 1 : 0);
    }
  };

  VHReels.prototype.preload = function (index) {
    var slide = this.slides[index];
    if (!slide || !slide._media || slide._media.getAttribute('src')) return;
    slide._media.preload = 'metadata';
    slide._media.src = slide._video.mp4;
  };

  VHReels.prototype.toggleSound = function () {
    this.muted = !this.muted;
    this.soundBtn.innerHTML = this.muted ? ICONS.soundOff : ICONS.soundOn;
    this.soundBtn.setAttribute('aria-label', this.muted ? 'Ativar som' : 'Desativar som');

    var slide = this.slides[this.index];
    if (slide._media) slide._media.muted = this.muted;
    else if (slide._frame) this.activate(slide);
  };

  VHReels.prototype.trapFocus = function (ev) {
    var focusables = this.modal.querySelectorAll(
      'button:not([disabled]), a[href], input, textarea, [tabindex]:not([tabindex="-1"])'
    );
    var list = Array.prototype.filter.call(focusables, function (node) {
      return node.offsetParent !== null;
    });
    if (!list.length) return;

    var first = list[0];
    var last = list[list.length - 1];

    if (ev.shiftKey && document.activeElement === first) {
      ev.preventDefault();
      last.focus();
    } else if (!ev.shiftKey && document.activeElement === last) {
      ev.preventDefault();
      first.focus();
    }
  };

  /* --------------------------------------------------------------- curtidas */

  VHReels.prototype.likedIds = function () {
    return store(LS_LIKES, {});
  };

  VHReels.prototype.renderLike = function (slide, video) {
    if (!slide._like) return;
    var liked = !!this.likedIds()[video.id];
    slide._like.classList.toggle('is-liked', liked);
    slide._like.setAttribute('aria-pressed', liked ? 'true' : 'false');
    slide._like.setAttribute('aria-label', liked ? 'Remover curtida' : 'Curtir vídeo');
    slide._likeCount.textContent = formatCount((video.likes || 0) + (liked ? 1 : 0));
  };

  VHReels.prototype.toggleLike = function (i) {
    var slide = this.slides[i];
    var video = slide._video;
    var likes = this.likedIds();
    var liked = !likes[video.id];

    if (liked) likes[video.id] = Date.now();
    else delete likes[video.id];

    save(LS_LIKES, likes);
    this.renderLike(slide, video);
    this.report({ type: liked ? 'like' : 'unlike', videoId: video.id, videoTitle: video.title });
  };

  /* ------------------------------------------------------------ comentários */

  VHReels.prototype.buildCommentsPanel = function (stage, player) {
    var self = this;
    var cfg = this.cfg;

    var panel = el('section', 'vh-reels__comments');
    panel.setAttribute('aria-label', cfg.commentsTitle || 'Comentários');

    var head = el('div', 'vh-reels__comments-head', panel);
    var title = el('h4', 'vh-reels__comments-title', head);
    title.textContent = cfg.commentsTitle || 'Comentários';

    var closeC = el('button', 'vh-reels__comments-close', head);
    closeC.type = 'button';
    closeC.innerHTML = ICONS.close;
    closeC.setAttribute('aria-label', 'Fechar comentários');
    closeC.addEventListener('click', function () { self.toggleComments(false); });

    var list = el('ul', 'vh-reels__comments-list', panel);

    var form = el('form', 'vh-reels__comments-form', panel);
    form.noValidate = true;

    var name = el('input', null, form);
    name.type = 'text';
    name.maxLength = 40;
    name.placeholder = cfg.namePlaceholder || 'Seu nome';
    name.setAttribute('aria-label', cfg.namePlaceholder || 'Seu nome');
    name.value = store(LS_NAME, '') || '';

    var text = el('textarea', null, form);
    text.rows = 2;
    text.maxLength = 400;
    text.placeholder = cfg.commentPlaceholder || 'Escreva um comentário...';
    text.setAttribute('aria-label', cfg.commentPlaceholder || 'Escreva um comentário');

    var send = el('button', 'vh-reels__comments-send', form);
    send.type = 'submit';
    send.innerHTML = ICONS.send;
    send.setAttribute('aria-label', cfg.sendLabel || 'Enviar comentário');

    var note = el('p', 'vh-reels__comments-note', form);
    note.textContent = cfg.commentsNote || '';

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      self.submitComment(name.value, text.value, note, text, send);
    });

    // o painel é irmão do player no desktop e sobrepõe o player no mobile
    if (window.matchMedia('(max-width: 749px)').matches) player.appendChild(panel);
    else stage.appendChild(panel);

    this.commentsPanel = panel;
    this.commentsList = list;
    this.commentsNote = note;
    this.commentsName = name;
    this.commentsText = text;
  };

  VHReels.prototype.toggleComments = function (open) {
    if (!this.commentsPanel) return;
    this.commentsPanel.classList.toggle('is-open', !!open);
    if (open) {
      this.renderComments();
      this.fetchComments();
    }
  };

  VHReels.prototype.localComments = function (videoId) {
    return store(LS_COMMENTS, {})[videoId] || [];
  };

  VHReels.prototype.allComments = function (video) {
    var seeds = (video.comments || []).map(function (c) {
      return { name: c.name, text: c.text, meta: c.date || '', seed: true };
    });
    var remote = (this.remote && this.remote[video.id]) || [];
    var mine = this.localComments(video.id).map(function (c) {
      return { name: c.name, text: c.text, meta: timeAgo(c.ts) };
    });
    return seeds.concat(remote, mine);
  };

  VHReels.prototype.renderComments = function () {
    if (!this.commentsList) return;

    var video = this.videos[this.index];
    var items = this.allComments(video);
    var list = this.commentsList;
    list.textContent = '';

    var slide = this.slides[this.index];
    if (slide && slide._commentCount) {
      slide._commentCount.textContent = items.length ? formatCount(items.length) : '';
    }

    if (!items.length) {
      var empty = el('li', 'vh-reels__comments-empty', list);
      empty.textContent = this.cfg.emptyComments || 'Seja o primeiro a comentar.';
      return;
    }

    items.forEach(function (c) {
      var li = el('li', 'vh-reels__comment', list);
      var avatar = el('div', 'vh-reels__comment-avatar', li);
      avatar.textContent = (c.name || '?').trim().charAt(0);

      var body = el('div', 'vh-reels__comment-body', li);
      var author = el('div', 'vh-reels__comment-author', body);
      author.textContent = c.name || 'Visitante';

      var txt = el('p', 'vh-reels__comment-text', body);
      txt.textContent = c.text;

      if (c.meta) {
        var meta = el('div', 'vh-reels__comment-meta', body);
        meta.textContent = c.meta;
      }
    });
  };

  VHReels.prototype.submitComment = function (name, text, note, textField, send) {
    var self = this;
    name = (name || '').trim();
    text = (text || '').trim();

    note.className = 'vh-reels__comments-note';

    if (text.length < 2) {
      note.textContent = 'Escreva um comentário antes de enviar.';
      note.classList.add('is-error');
      return;
    }
    if (!name) name = 'Visitante';

    var video = this.videos[this.index];
    var all = store(LS_COMMENTS, {});
    all[video.id] = (all[video.id] || []).concat([{ name: name, text: text, ts: Date.now() }]);

    save(LS_COMMENTS, all);
    save(LS_NAME, name);

    textField.value = '';
    this.renderComments();

    note.textContent = this.cfg.commentsNote || '';

    send.disabled = true;
    this.report({
      type: 'comment',
      videoId: video.id,
      videoTitle: video.title,
      name: name,
      text: text
    }).then(function (ok) {
      send.disabled = false;
      if (!ok) return;
      note.textContent = self.cfg.commentSent || 'Comentário enviado para moderação.';
      note.classList.add('is-success');
    });
  };

  VHReels.prototype.fetchComments = function () {
    var self = this;
    var url = this.cfg.commentsFetchUrl;
    var video = this.videos[this.index];
    if (!url) return;

    this.remote = this.remote || {};
    if (this.remote[video.id]) return;

    var sep = url.indexOf('?') > -1 ? '&' : '?';
    window.fetch(url + sep + 'videoId=' + encodeURIComponent(video.id), {
      method: 'GET',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        var arr = Array.isArray(data) ? data : data.comments;
        if (!Array.isArray(arr)) return;

        self.remote[video.id] = arr
          .filter(function (c) { return c && c.text; })
          .map(function (c) {
            return { name: String(c.name || 'Visitante'), text: String(c.text), meta: String(c.date || '') };
          });
        self.renderComments();
      })
      .catch(function () { /* endpoint fora do ar não pode derrubar o painel */ });
  };

  /* ------------------------------------------------------- webhook / share */

  VHReels.prototype.report = function (payload) {
    var url = this.cfg.webhookUrl;
    if (!url || !window.fetch) return Promise.resolve(false);

    payload.shop = window.location.hostname;
    payload.page = window.location.pathname;
    payload.at = new Date().toISOString();

    return window.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.ok; })
      .catch(function () { return false; });
  };

  VHReels.prototype.share = function (i) {
    var video = this.videos[i];
    var url = video.ctaLink
      ? new URL(video.ctaLink, window.location.origin).href
      : window.location.href;

    if (navigator.share) {
      navigator.share({ title: video.title || document.title, url: url }).catch(function () {});
      return;
    }

    if (navigator.clipboard) {
      var self = this;
      navigator.clipboard.writeText(url).then(function () {
        if (self.commentsNote) {
          self.commentsNote.textContent = 'Link copiado.';
          self.commentsNote.className = 'vh-reels__comments-note is-success';
        }
      }).catch(function () {});
    }
  };

  /* ------------------------------------------------------------------ boot */

  var instances = [];

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-vh-reels]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root._vhReels) return;
      root._vhReels = new VHReels(root);
      instances.push(root._vhReels);
    });
  }

  document.addEventListener('click', function (ev) {
    var alvo = ev.target && ev.target.closest ? ev.target.closest('[data-vh-open]') : null;
    if (!alvo) return;

    var root = alvo.closest('[data-vh-reels]');
    if (!root || root._vhReels) return;   // ja montado: setupGrid trata

    ev.preventDefault();
    boot(document);
    if (root._vhReels) root._vhReels.open(parseInt(alvo.getAttribute('data-vh-open'), 10) || 0);
  });

  function start() {
    // A bolha não disputa banda com o conteúdo principal: espera a carga
    // terminar e, onde houver, um momento ocioso.
    if (window.requestIdleCallback) window.requestIdleCallback(function () { boot(); }, { timeout: 2500 });
    else window.setTimeout(function () { boot(); }, 600);
  }

  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);

  // Editor de tema: recriar ao recarregar a seção, abrir ao selecioná-la.
  document.addEventListener('shopify:section:load', function (ev) {
    var root = ev.target.querySelector('[data-vh-reels]');
    if (root) { root._vhReels = null; boot(ev.target); }
  });

  document.addEventListener('shopify:section:select', function (ev) {
    var root = ev.target.querySelector('[data-vh-reels]');
    if (root && root._vhReels) root._vhReels.open(0);
  });

  document.addEventListener('shopify:section:deselect', function (ev) {
    var root = ev.target.querySelector('[data-vh-reels]');
    if (root && root._vhReels) root._vhReels.close();
  });
})();
